// extracted by mini-css-extract-plugin
module.exports = {"component":"Brands_component__gjJZ6","on3":"Brands_on3__SzqjA","rivals":"Brands_rivals__bj_C_","divider":"Brands_divider__08OGg","small":"Brands_small__sU_46"};